import http from '@/utils/http'

export function getBranchSchools(params){
    return http.get('/branch_schools',{params})
}
export function addBranchSchools(data){
    return http.post('/branch_schools',data)
}
export function getBranchSchoolsDetail(id){
    return http.get(`/branch_schools/${id}`)
}
export function deleteBranchSchools(id){
    return http.delete(`/branch_schools/${id}`)
}
export function editBranchSchools(id,data){
    return http.put(`/branch_schools/${id}`,data)
}
export function getAreas(params){
    return http.get('/areas',{params})
}
export function getDistricts(params){
    return http.get('/districts',{params})
}
export function getCountries(params){
    return http.get('/countries',{params})
}
export function getAreaCodes(params){
    return http.get('/area_codes',{params})
}
export function getGrades(params){
    return http.get('/grades',{params})
}
export function editGrades(id,data){
    return http.put(`/grades/${id}`,data)
}
export function getWebFaqs(params){
    return http.get('/faqs',{params})
}
export function addWebFaqs(data){
    return http.post('/batch_edit_faqs',data)
}

export function getQuestionFeedbackCategories(params){
    return http.get('/question_feedback_categories',{params})
}
export function addQuestionFeedbackCategories(data){
    return http.post('/question_feedback_categories',data)
}
export function getQuestionFeedbackCategoriesDetail(id){
    return http.get(`/question_feedback_categories/${id}`)
}
export function deleteQuestionFeedbackCategories(id){
    return http.delete(`/question_feedback_categories/${id}`)
}
export function editQuestionFeedbackCategories(id,data){
    return http.put(`/question_feedback_categories/${id}`,data)
}



export function getQuestionFeedbacks(params){
    return http.get('/question_feedbacks',{params})
}
export function updateState(params){
    return http.put('/question_updateState',params)
}
export function getQuestionFeedbacksDetail(id){
    return http.get(`/question_feedbacks/${id}`)
}


export function getBanners(params){
    return http.get('/banners',{params})
}
export function addBatchEditBanners(data){
    return http.post('/batch_edit_banners',data)
}


export function getSubscriptionUpgradeDates(params){
    return http.get('/subscription_upgrade_dates',{params})
}
export function addSubscriptionUpgradeDates(data){
    return http.post('/subscription_upgrade_dates',data)
}



export function getStudentCodes(params){
    return http.get('/student_codes',{params})
}
export function addStudentCodes(data){
    return http.post('/student_codes',data)
}
export function getStudentCodesDetail(id){
    return http.get(`/student_codes/${id}`)
}
export function deleteStudentCodes(id){
    return http.delete(`/student_codes/${id}`)
}
export function editStudentCodes(id,data){
    return http.put(`/student_codes/${id}`,data)
}

export function importStudentCodes(data){
    return http.post('/import_student_codes',data)
}